import actionTypes from "../action-types";
import { EmbeddedAnswerMark } from "../models/Assignee/QuestionStat";
import { TeacherAssignmentReceived } from "../models/TeacherAssignmentReceived";

export function receiveAssignment(assignment: TeacherAssignmentReceived) {
  return {
    type: actionTypes.RECEIVE_ASSIGNMENT,
    payload: assignment
  };
}

export function receiveAssignments(assignments: TeacherAssignmentReceived[]) {
  return {
    type: actionTypes.RECEIVE_ASSIGNMENTS,
    payload: assignments
  };
}

export function deleteAssignment(assignmentId: string) {
  return {
    type: actionTypes.DELETE_ASSIGNMENT,
    payload: assignmentId
  };
}

export type UpdatedMarks = {
  assignmentId: string;
  assigneeId: string;
  questionId: string;
  teacherMark?: number;
  embeddedAnswerMarks?: EmbeddedAnswerMark[];
  allMarked?: boolean;
};

export function initialiseAssignmentQuestionMarksState(
  payload: UpdatedMarks[]
) {
  return {
    type: actionTypes.FETCHED_ASSIGNMENT_QUESTION_MARKS,
    payload
  };
}

export function updateAssignmentQuestionMarks(payload: UpdatedMarks) {
  return {
    type: actionTypes.UPDATE_ASSIGNMENT_QUESTION_MARKS,
    payload
  };
}

export type UpdatedEmbeddedMarks = {
  assignmentId: string;
  assigneeId: string;
  questionId: string;
  embeddedAnswerMarks: EmbeddedAnswerMark[];
  allMarked: boolean;
};

export function updateAssignmentEmbeddedQuestionMark(
  payload: UpdatedEmbeddedMarks
) {
  return {
    type: actionTypes.UPDATE_ASSIGNMENT_EMBEDDED_QUESTION_MARK,
    payload
  };
}

type UpdatedAggregates = {
  assigneeId: string;
  assignmentId: string;
  assignmentAverageMark: number;
  sumQuestionMarks: number;
};

export function updateAssignmentAggregates(payload: UpdatedAggregates) {
  return {
    type: actionTypes.UPDATE_ASSIGNMENT_QUESTIONS_AGGREGATES,
    payload
  };
}
